module.exports = __webpack_public_path__ + "static/media/customer-success-trimble-feature.2fd9b035.jpg";